/**
 * Performs DTM direct call tracking
 *
 * Launch loads async, so events fired before _satellite exists are queued and
 * drained in order once it loads. Payloads are shallow-copied at call time and
 * the data layer is updated per event at drain time.
 */

// Adapted from waitForSatellite in packages/utils/analytics/adobe/directCall.ts.
function waitForSatellite(callback, onTimeout, timeout = 5000, interval = 200) {
  const start = Date.now();

  (function check() {
    if (window._satellite) {
      callback();
    } else if (Date.now() - start < timeout) {
      setTimeout(check, interval);
    } else {
      onTimeout();
    }
  })();
}

const queue = [];
let waitingForSatellite = false;

function fire({ name, dataLayerProperties }) {
  if (dataLayerProperties !== null && window.webDigitalData) {
    window.webDigitalData = {
      ...window.webDigitalData,
      direct_call: dataLayerProperties,
    };
  }

  window._satellite.track(name);
}

function drainQueue() {
  waitingForSatellite = false;

  while (queue.length > 0) {
    fire(queue.shift());
  }
}

/**
 * @param {string} name - the direct call name
 * @param {obj} dataLayerProperties - values that we want to add to the data layer to set as eVars
 */
const aaTrackEvent = (name, dataLayerProperties = null) => {
  queue.push({
    name,
    dataLayerProperties: dataLayerProperties !== null ? { ...dataLayerProperties } : null,
  });

  if (window._satellite) {
    drainQueue();
    return;
  }

  if (!waitingForSatellite) {
    waitingForSatellite = true;

    waitForSatellite(drainQueue, () => {
      waitingForSatellite = false;
    });
  }
};

export default aaTrackEvent;
